export class RewardProgramTypes {
    public static PER_ITEM = 'PER_ITEM';
    public static PER_DOLLAR = 'PER_DOLLAR';
}
